import api from './api';
import { VehicleRental, VehicleRentalStatus } from '../types';

const vehicleRentalService = {
  list: async (): Promise<VehicleRental[]> => {
    const res = await api.get('/vehicle-rentals');
    return res.data ?? [];
  },

  getById: async (id: number): Promise<VehicleRental> => {
    const res = await api.get(`/vehicle-rentals/${id}`);
    return res.data;
  },

  create: async (data: Partial<VehicleRental>): Promise<VehicleRental> => {
    const res = await api.post('/vehicle-rentals', data);
    return res.data;
  },

  update: async (id: number, data: Partial<VehicleRental>): Promise<VehicleRental> => {
    const res = await api.put(`/vehicle-rentals/${id}`, data);
    return res.data;
  },

  updateStatus: async (id: number, status: VehicleRentalStatus): Promise<VehicleRental> => {
    const res = await api.patch(`/vehicle-rentals/${id}/status`, { status });
    return res.data;
  },
};

export default vehicleRentalService;
